/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import * as _ from 'lodash';

@Component({
  selector: 'edit-beneficiary-info',
  template: require('./edit-beneficiary-info.component.html')
})

export class EditBeneficiaryInfoComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);

    this.marriedSelectedPrimary = this.flowManager.isMarried;
    this.beneficiaryInfo = this.appActions.getData("BeneficiaryInformation");
    this.primaryEditing = {};
    this.contingentEditing = {};
    this.pFormTitle = "Add New Beneficiary";
    this.cFormTitle = "Add New Beneficiary";

    // Load in all primary users from the store
    if (this.beneficiaryInfo !== null) {
      if (this.beneficiaryInfo.Primary.length > 0) {
        for(let i in this.beneficiaryInfo.Primary) {
          let primaryBeneficiaryPerson = this.beneficiaryInfo.Primary[i];
          let editable = { "editable": true, "type": "P" };
          primaryBeneficiaryPerson = Object.assign({}, primaryBeneficiaryPerson, editable);
          this.form.Primary.push(primaryBeneficiaryPerson);
        }
      }

      // Load in all contingent users from the store
      if (this.beneficiaryInfo.Contingent !== undefined && this.beneficiaryInfo.Contingent.length > 0) {
        for(let i in this.beneficiaryInfo.Contingent) {
          let contingentBeneficiaryPerson = this.beneficiaryInfo.Contingent[i];
          let editable = { "editable": true, "type": "C" };
          contingentBeneficiaryPerson = Object.assign({}, contingentBeneficiaryPerson, editable);
          this.form.Contingent.push(contingentBeneficiaryPerson);
        }
      }
    }
    this.primaryNameList = this.form.Primary;
    this.contingentNameList = this.form.Contingent;
    this.primaryIndex = 0;
    this.contingentIndex = 0;
    let formData = this.form;
    this._onlyPrimary(formData);

    const steps = this.flowManager.getStepArrays('edit-beneficiary-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    this._validateTotal();
    this._checkMaxBene();
  }

  close() {
    let _this = this;

    let cb = function() {
      let formData = _this.form;
      formData.primaryFormTitle = _this.pFormTitle;
      formData.contingentFormTitle = _this.cFormTitle;
      _this.primaryEditing = {};
      _this.contingentEditing = {};
      for (let i = 0; i<_this.primaryNameList.length; i++) {
        _this.primaryNameList[i].editable = true;
      }
      for (let i = 0; i<_this.contingentNameList.length; i++) {
        _this.contingentNameList[i].editable = true;
      }
      formData.Primary = _this.primaryNameList;
      formData.Contingent = _this.contingentNameList;
      if ((formData.Primary.length + formData.Contingent.length)>=4) {
        formData.hidePrimaryAddBtn = true;
        formData.hideContingentAddBtn = true;
      } else {
        formData.hidePrimaryAddBtn = false;
        formData.hideContingentAddBtn = false;
      }
      _this._setPrimarySpousalConsent(false);
      // _this._setContingentSpousalConsent(false);
      formData.hidePrimaryHeader = true;
      formData.hidePrimaryForm = true;
      formData.hideContingentHeader = true;
      formData.hideContingentForm = true;
      formData.showNext = true;
      _this._onlyPrimary(formData);
      _this._validateTotal();
      _this._clearArray();
    }




    this.modal.beneficiaryConfirm('Are you sure you want to cancel?', cb);
    this._validateTotal();
  }

  primaryAddButtonClicked(event) {
    let formData = this.form;
    let pLength = this.primaryNameList.length;
    let cLength = this.contingentNameList.length;
    this.appActions.deleteData('BeneficiaryInformation.Temp');
    formData.editingPrimaryPercent = "0%";
    this._setPrimarySpousalConsent(false);
    for (let i = 0; i<pLength; i++) {
      this.primaryNameList[i].editable = false;
    }
    for (let i = 0; i<cLength; i++) {
      this.contingentNameList[i].editable = false;
    }
    formData.Primary = this.primaryNameList;
    formData.Contingent = this.contingentNameList;
  	formData.hidePrimaryAddBtn = true;
  	formData.hidePrimaryHeader = false;
  	formData.hidePrimaryForm = false;
  	formData.hideContingentAddBtn = true;
  	formData.hideContingentHeader = true;
  	formData.hideContingentForm = true;
    formData.primaryFormTitle = this.pFormTitle;
    formData.contingentFormTitle = this.cFormTitle;
    formData.showNext = false;
  }

  contingentAddButtonClicked(event) {
  	let formData = this.form;
    let pLength = this.primaryNameList.length;
    let cLength = this.contingentNameList.length;
    this.appActions.deleteData('BeneficiaryInformation.Temp', {});
    formData.editingContingentPercent = "0%";
    this._setPrimarySpousalConsent(false);
    for (let i = 0; i<pLength; i++) {
      this.primaryNameList[i].editable = false;
    }
    for (let i = 0; i<cLength; i++) {
      this.contingentNameList[i].editable = false;
    }
    formData.Contingent = this.contingentNameList;
  	formData.hidePrimaryAddBtn = true;
  	formData.hidePrimaryHeader = true;
  	formData.hidePrimaryForm = true;
  	formData.hideContingentAddBtn = true;
  	formData.hideContingentHeader = false;
  	formData.hideContingentForm = false;
    formData.primaryFormTitle = this.pFormTitle;
    formData.contingentFormTitle = this.cFormTitle;
    formData.showNext = false;
  }

  updateOptionValue(event) {
    if (event.id === 'primaryBeneRelationship') {
      this._checkPrimarySpousalConsent(event.value);
      if (event.value !== 'Spouse' && this.marriedSelectedPrimary === true) {
        this.appActions.setData('BeneficiaryInformation.Temp.spousalConsent', true);
      } else {
        this.appActions.setData('BeneficiaryInformation.Temp.spousalConsent', false);
      }
    }
  }

  updateBtnClicked(e) {
  	let formData = this.form;
  	let primaryNo = this.primaryNameList.length;
  	let contingentNo = this.contingentNameList.length;
  	try {
      if (e.action === 'primaryCancel' || e.action ==='contingentCancel') {
        this.appActions.deleteData('BeneficiaryInformation.PrimaryIndex');
        this.appActions.deleteData('BeneficiaryInformation.ContingentIndex');
        this.close();
        this.validation.validCheck('clear');
        return;
      }
  	  if (e.action === 'submitPrimaryInfo') {
        try {
          this.appActions.deleteData('BeneficiaryInformation.PrimaryIndex');
          const newData = this.appActions.getData('BeneficiaryInformation.Temp');
          if (this.primaryEditing.firstName) {
            const index = this.primaryNameList.indexOf(this.primaryEditing);
            const currentData = this.appActions.getData(`BeneficiaryInformation.Primary[${index}]`, {});
            let changedPrimary = Object.assign({}, currentData, newData, { "editable": true, type: "P" });
            this.appActions.setData(`BeneficiaryInformation.Primary[${index}]`, changedPrimary);
            this.primaryNameList.splice(index, 1, changedPrimary);
            this.primaryEditing = {};
          } else {
            let newPrimary = Object.assign({}, newData, { "editable": true, type: "P" });
            this.primaryNameList.push(newPrimary);
            this.appActions.setData(`BeneficiaryInformation.Primary[${primaryNo}]`, newPrimary);

            primaryNo++;
          }
          for (let i = 0; i<this.primaryNameList.length; i++) {
            this.primaryNameList[i].editable = true;
          }
          for (let i = 0; i<this.contingentNameList.length; i++) {
            this.contingentNameList[i].editable = true;
          }
          formData.Primary = this.primaryNameList;
          formData.Contingent = this.contingentNameList;
          formData.hidePrimaryAddBtn = false;
          formData.hideContingentAddBtn = false;
          formData.hidePrimaryHeader = true;
          formData.hidePrimaryForm = true;
          formData.primaryFormTitle = this.pFormTitle;
          formData.contingentFormTitle = this.cFormTitle;
          if ((primaryNo+contingentNo) >= 4){
            formData.hidePrimaryAddBtn = true;
            formData.hideContingentAddBtn = true;
          }
          this.primaryEditing = {};
          this.contingentEditing = {};
          this._onlyPrimary(formData);
          formData.showNext = true;
          this._clearArray();
        } catch (e) {
        }

        return;
  	  }

  	  if (e.action === 'submitContingentInfo') {
        this.appActions.deleteData('BeneficiaryInformation.ContingentIndex');
        const newData = this.appActions.getData('BeneficiaryInformation.Temp');
        if (this.contingentEditing.firstName) {
          const index = this.contingentNameList.indexOf(this.contingentEditing);
          const currentData = this.appActions.getData(`BeneficiaryInformation.Contingent[${index}]`);
          let changedContingent = Object.assign({}, currentData, newData, { "editable": true, type: "C" });

          this.appActions.setData(`BeneficiaryInformation.Contingent[${index}]`, changedContingent);
          this.contingentNameList.splice(index, 1, changedContingent);
          this.contingentEditing = {};
        } else {
          let newContingent = Object.assign({}, newData, { "editable": true, type: "C" });
          this.contingentNameList.push(newContingent);
          this.appActions.setData(`BeneficiaryInformation.Contingent[${contingentNo}]`, newContingent);

          contingentNo++;
        }
        for (let i = 0; i<this.primaryNameList.length; i++) {
          this.primaryNameList[i].editable = true;
        }
        for (let i = 0; i<this.contingentNameList.length; i++) {
          this.contingentNameList[i].editable = true;
        }
        formData.Primary = this.primaryNameList;
        formData.Contingent = this.contingentNameList;
        formData.hidePrimaryAddBtn = false;
  	    formData.hideContingentAddBtn = false;
  	    formData.hideContingentHeader = true;
  	    formData.hideContingentForm = true;
        formData.primaryFormTitle = this.pFormTitle;
        formData.contingentFormTitle = this.cFormTitle;
  	    if ((primaryNo+contingentNo) >= 4){
  	      formData.hidePrimaryAddBtn = true;
  	      formData.hideContingentAddBtn = true;
  	    }
        this.primaryEditing = {};
        this.contingentEditing = {};
        this._onlyPrimary(formData);
        formData.showNext = true;
        this._clearArray();
        return;
  	  }
  	} catch(e) {
  	}

    if (e.action == 'next') {
      if (this._validateTotal() === false) {
        return;
      }
    }

    this.handleClick(e.action);
  }

  _validateTotal() {
    let primary = this.form.Primary;
    let contingent = this.form.Contingent;
    let primaryWarning = document.getElementById('PrimarybeneficiaryPercentError');
    let contingentError = document.getElementById('ContingentbeneficiaryPercentError');

    let validation = true;

    if (primaryWarning != null && primary.length > 0) {
      let primaryTotal = primary.map(p => parseInt(p.percent)).reduce((a,b) => a + b);
      if (primaryTotal !== 100) {
        primaryWarning.style.display = 'block';
        validation = false;
      } else {
        primaryWarning.style.display = 'none';
      }
    }

    if (contingentError != null && contingent.length > 0) {
      let contingentTotal = contingent.map(p => parseInt(p.percent)).reduce((a,b) => a + b);
      if (contingentTotal !== 100) {
        contingentError.style.display = 'block';
        validation = false;
      } else {
        contingentError.style.display = 'none';
      }
    }

    return validation;
  }

  nextBtnClicked(event) {
  }

  primaryEditButtonClicked(event) {
    let formData = this.form;
    let index = this.primaryNameList.indexOf(event);
    this.appActions.setData('BeneficiaryInformation.PrimaryIndex', index);
    // Load user into temp
    const currentData = this.appActions.getData(`BeneficiaryInformation.Primary[${index}]`);
    this.appActions.setData('BeneficiaryInformation.Temp', currentData);

    this.primaryEditing = event;
    formData.editingPrimaryPercent = `${this.primaryEditing.percent}%`;
    formData.Primary = [];
    formData.afterPrimary = [];
    formData.afterContingent = [];
    for (let i = 0; i<index; i++) {
      formData.Primary.push(this.primaryNameList[i]);
      formData.Primary[i].editable = false;
    }
    for (let i = (index+1); i<this.primaryNameList.length; i++) {
      formData.afterPrimary.push(this.primaryNameList[i]);
    }
    for (let i = 0; i<formData.Contingent.length; i++) {
      formData.Contingent[i].editable = false;
    }
    formData.hidePrimaryForm = false;
    formData.hidePrimaryAddBtn = true;
    formData.primaryFormTitle = `${this.primaryEditing.firstName} ${this.primaryEditing.lastName}`;
    formData.hidePrimaryHeader = false;
    formData.contingentFormTitle = this.cFormTitle;
    formData.hideContingentAddBtn = true;
    formData.hideContingentHeader = true;
    formData.hideContingentForm = true;
    formData.showNext = false;
    if (this.primaryEditing && this.primaryEditing.spousalConsent === true) {
      this._setPrimarySpousalConsent(true);
    } else {
      this._setPrimarySpousalConsent(false);
    }
  }

  primaryRemoveButtonClicked(event) {
    let _this = this;

    let cb = function() {
      let formData = _this.form;
      if (formData.Primary) {
        if (formData.Primary.length>1) {
          const index = formData.Primary.indexOf(event);
          _this.appActions.deleteArrayIndex('BeneficiaryInformation.Primary', index);
          formData.Primary.splice(index, 1);
          _this.primaryNameList = formData.Primary;
          if ((formData.Primary.length + formData.Contingent.length) === 3) {
            formData.hidePrimaryAddBtn = false;
            formData.hideContingentAddBtn = false;
          }
        }
        _this._onlyPrimary(formData);
        _this._validateTotal();
      };
    }

    this.modal.beneficiaryConfirm('Are you sure you want to delete this beneficiary?', cb);
    this._validateTotal();
  }

  contingentEditButtonClicked(event) {
    let formData = this.form;
    let index = this.contingentNameList.indexOf(event);
    this.appActions.setData('BeneficiaryInformation.ContingentIndex', index);
    const currentData = this.appActions.getData(`BeneficiaryInformation.Contingent[${index}]`);
    this.appActions.setData('BeneficiaryInformation.Temp', currentData);

    this.contingentEditing = event;
    formData.editingContingentPercent = `${this.contingentEditing.percent}%`;
    formData.Contingent = [];
    formData.afterPrimary = [];
    formData.afterContingent = [];
    for (let i = 0; i<index; i++) {
      formData.Contingent.push(this.contingentNameList[i]);
      formData.Contingent[i].editable = false;
    }
    for (let i = (index+1); i<this.contingentNameList.length; i++) {
      formData.afterContingent.push(this.contingentNameList[i]);
    }
    for (let i = 0; i<formData.Primary.length; i++) {
      formData.Primary[i].editable = false;
    }
    formData.hidePrimaryForm = true;
    formData.hidePrimaryAddBtn = true;
    formData.primaryFormTitle = this.pFormTitle;
    formData.hidePrimaryHeader = true;
    formData.contingentFormTitle = `${this.contingentEditing.firstName} ${this.contingentEditing.lastName}`
    formData.hideContingentAddBtn = true;
    formData.hideContingentHeader = false;
    formData.hideContingentForm = false;
    formData.showNext = false;
  }

  contingentRemoveButtonClicked(event) {
    let _this = this;

    let cb = function() {
      let formData = _this.form;
      if (formData.Contingent) {
        const index = formData.Contingent.indexOf(event);
        _this.appActions.deleteArrayIndex('BeneficiaryInformation.Contingent', index);
        formData.Contingent.splice(index, 1);
        _this.contingentNameList = formData.Contingent;
        if ((formData.Primary.length + formData.Contingent.length) === 3) {
          formData.hidePrimaryAddBtn = false;
          formData.hideContingentAddBtn = false;
        }
      }
      _this._onlyPrimary(formData);
      _this._validateTotal();
    }

    this.modal.beneficiaryConfirm('Are you sure you want to delete this beneficiary?', cb);
    this._validateTotal();
  }

  _checkPrimarySpousalConsent(value) {
    if (this.marriedSelectedPrimary === true && value !== 'Spouse') {
      this._setPrimarySpousalConsent(true);
    } else {
      this._setPrimarySpousalConsent(false);
    }
  }

  _setPrimarySpousalConsent(boolean) {
    this.form.primaryForm.inputs.spousalConsent.showUp = boolean;
  }

  _calculateOtherBeneficiary(value) {
    if (value <= 100) {
      return (100-value);
    }
    else {
      return 0;
    }
  }

  _onlyPrimary(form) {
    if (form.Primary.length === 1) {
      form.onlyPrimary = false;
    } else {
      form.onlyPrimary = true;
    }
  }

  _checkMaxBene() {
    let formData = this.form;
    let primary = this.form.Primary;
    let contingent = this.form.Contingent;
    if ((primary.length + contingent.length) >= 4) {
      formData.hideContingentAddBtn = true;
      formData.hidePrimaryAddBtn = true;
    }
  }

  _clearArray() {
    this.form.afterPrimary=[];
    this.form.afterContingent=[];
  }
}
